import React from 'react';
import { connect } from 'react-redux';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Card from '../Card';
import Tableau from '../Tableau';

const Entete = (
    <tr>
        <th scope="col">Lot</th>
        <th scope="col">Numéro</th>
        <th scope="col">Type</th>
        <th scope="col">Étage</th>
        <th scope="col">Libellé</th>
    </tr>
);

const LigneLot = ({
    Lot, Numero, Type, Etage, Libelle,
}) => (
    <tr>
        <td>
            <strong>{Lot}</strong>
        </td>
        <td>{Numero}</td>
        <td>{Type}</td>
        <td>{Etage}</td>
        <td>{Libelle}</td>
    </tr>
);

const CardLots = ({ LsLots }) => (
    <Card Titre={CardLots.titleName}>
        {LsLots.length === 0 ? (
            <p className="card-text">
                <i>Vous n&apos;avez pas de lots.</i>
            </p>
        ) : (
            <Tableau
                Entete={Entete}
                Lignes={LsLots.map(lot => <LigneLot key={lot.Lot} {...lot} />)}
                PasDeZebrures
                className="mb-0"
            />
        )}
    </Card>
);
CardLots.displayName = 'CardLots';
CardLots.titleName = 'Mes lots';
CardLots.requiredProps = [
    'LsLots', // Liste des lots
];

function mapStateToProps({
    ProStore: {
        Pro: { LsLots },
    },
}) {
    return { LsLots };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardLots));



// WEBPACK FOOTER //
// ./src/components/MesInfos/CardLots.js